<template>
    <div class="nrk lis">
        <img src='img/lxwmE-2.jpg' class="ims">
        <BaiduMap/>
    </div>
</template>

<script>
import BaiduMap from'@/components/BaiduMap'
export default {
    components:{
      BaiduMap
    } ,
}
</script>

<style scoped>
    .ims{
        width: 100%;
        margin: 20px 0;
        display: block;
    }
    .lis{
        padding: 40px 0;
    }
</style>